import PayeeType from "@/models/Accounts/Shared/Payees/PayeeType";

export default (payeeType: PayeeType) => {
    let returnVal = "Undefined";
    switch (payeeType) {
        case PayeeType.UK:
            returnVal = "UK"
            break;
        case PayeeType.IBAN:
            returnVal = "IBAN"
            break;
    }
    return returnVal;
}